import React from 'react'
import NavBarItem from "./NavBarItem";
import {IconBuildingStore, IconHome, IconPackage} from "@tabler/icons-react";
import {NavBarProfile} from "./NavBarProfile";

export function NavBar() {
    return (
        <header className="navbar navbar-expand-md d-print-none bg-hexagon-sky-dark border-white navbar-border-bottom" data-bs-theme="dark">
            <div className="container-xl">
                {/*<button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-menu"
                        aria-controls="navbar-menu" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>*/}
                <div className=" navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3">
                    <img src="/assets/logo.png" style={{height: '80px'}} alt="logo"/>
                </div>
                <div className="navbar-nav flex-row order-md-last">
                    <NavBarProfile />
                </div>


                <div className="collapse navbar-collapse" id="navbar-menu">
                    <ul className="navbar-nav iris-navbar">

                        <NavBarItem name={"Home"} icon={<IconHome />} state={"active"} />
                        <NavBarItem name={"Store"} icon={<IconBuildingStore />} />

                        {/*<li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="#navbar-base" data-bs-toggle="dropdown" data-bs-auto-close="outside" role="button" aria-expanded="false">
                            <IconBuildingStore />
                                <span class="nav-link-title"> Store </span>
                            </a>
                            <div class="dropdown-menu">
                                <div class="dropdown-menu-columns">
                                    <div class="dropdown-menu-column">
                                        <a class="dropdown-item" href="./accordion.html">
                                            Accordion
                                            <span class="badge badge-sm bg-green-lt text-uppercase ms-auto">New</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </li>*/}
                    </ul>
                </div>
            </div>
        </header>
)
}
